import { addClientTypeParam, addLpLoginParam, getUnityLpRegParams, isUnityLanding } from './landing';
import * as parseUrl from 'url-parse';
import { Environment } from '../environment/environment';

export function addLoginQueryParams(inUrl: string) {
    const urlObject = parseUrl(inUrl, true);
    const unityLpRegParams = getUnityLpRegParams();

    if (unityLpRegParams) {
        const [unityLpParam, unityLpValue] = unityLpRegParams.split('=');
        urlObject.set('query', {
            ...urlObject.query,
            [unityLpParam]: unityLpValue
        });
    }

    if (window.app.config.landings.enableFakeHardtutor) {
        const currentUrlObj = parseUrl(window.location.href, true);

        urlObject.set('query', {
            ...currentUrlObj.query,
            ...urlObject.query,
            state: 'instantGetUser'
        });
    }

    let url = urlObject.toString();

    if (!isUnityLanding()) {
        if (window.app.config.landings.startWebgl) {
            url = addClientTypeParam(url);
        }

        if (Environment.isLanding()) {
            url = addLpLoginParam(url);
        }
    }

    return url;
}
